export default {
  namespaced: true,
  state: {
    summary: [],
    totals: [],
    kpis: [],
    textHints: [],
    campaigns: [],
  },
  mutations: {
    SET_SUMMARY(state, data) {
      state.summary = data ?? [];
    },
    RESET_SUMMARY(state) {
      state.summary = [];
    },

    SET_TOTALS(state, data) {
      state.totals = data ?? [];
    },
    RESET_TOTALS(state) {
      state.totals = [];
    },

    SET_KPIS(state, data) {
      state.kpis = data ?? [];
      if (data.metrics_help) state.textHints = data.metrics_help;
    },
    RESET_KPIS(state) {
      state.kpis = [];
    },

    SET_TEXT_HINTS(state, data) {
      state.textHints = data ?? [];
    },
    RESET_TEXT_HINTS(state) {
      state.textHints = [];
    },

    SET_CAMPAIGNS(state, data) {
      state.campaigns = data ?? [];
    },
    RESET_CAMPAIGNS(state) {
      state.campaigns = [];
    },
  },
};
